
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
import { ConstituentLevelConversionData } from "@oldDashboard/legacyModels/constituentLevelConversionData.model";
import { constituentLevelConversionSerializerData } from "@oldDashboard/legacyModels/serializers/constituentLevelConversionSerializerData";

export class CommandConstituentLevelConversion {

    async run(launchSelected: String ) {
        const path = `constituent-level-conversions/?launch_id=${launchSelected}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response);
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : ConstituentLevelConversionData{
        const serializer = new constituentLevelConversionSerializerData();
        const dataChart = {
            ...data.chart_data,
            show_student_conversions_tile: data.show_student_conversions_tile
        }
        return serializer.deserialize(dataChart);
    }
}
